import React from 'react';
import PropTypes from 'prop-types';
import Autocomplete from './autocomplete';
import DateFilter from './dateFilterInit';
import TimePicker from './timePicker';
import TableRow from './tableRow';

const validateDate = (filter, date) => {
  let dateValue;
  if (filter) {
    dateValue = filter;
  } else if (date) {
    dateValue = date.substring(0, 10);
  } else {
    dateValue = new Date();
  }
  return dateValue;
};

const Table = props => (
  <div className="module-table top">
    <table>
      <thead className="th-border-left">
        <tr>
          <th className="left">
            {/*props.language.account.homologationDriver.table.source*/}
            Persona
            <div>
              <i className="fas fa-question-circle" />
              <span>{/*props.language.account.homologationDriver.table.dataSource*/}</span>
            </div>
          </th>
          <th className="left">
            {/*props.language.account.homologationDriver.table.code*/}
            Equipo
          </th>
          <th className="left">
            {/*props.language.account.homologationDriver.table.alias*/}
            Inicio
          </th>
          <th className="left">
            {/*props.language.account.homologationDriver.table.codeAndName*/}
            Fin (Opcional)
          </th>
        </tr>
      </thead>
      <tbody>
        <tr key={`row-${1}`} id={`row-${1}`}>
          <td>
            <span className="border-tr-left" />
            <input id={`homologation-id-${1}`} type="hidden" data-homologation="ok" />
            <div className="box-form">
              <Autocomplete
                value={props.value}
                memory={props.memory}
                id={`au-${1}`}
                correlativo={`${1}`}
                alias="alias"
                aliasTwo="code"
                select="alias"
                className="font-famiy-homologationDriver"
                idItem="id"
                filter={props.datosAccount}
                handleSubmit={props.handleSubmit}
                handleSubmitAutoComplete={props.handleSubmitAutoComplete}
                checkIfExist={props.checkIfExist}
                handleDriverName={props.handleDriverName}
                clear={props.clear}
                unClear={props.unClear}
                focus={props.focus}
                handleFocus={props.handleFocus}
                clearRow={props.clearRow}
                resetClear={props.resetClear}
                handleSelect={props.handleSelect}
                allocatorActions={props.allocatorActions}
              />
            </div>
          </td>

          <td className="relative-position">
            <input id={`homologation-id-${1}`} type="hidden" data-homologation="ok" />
            <div className="box-form">
              <Autocomplete
                value={props.value}
                memory={props.memory}
                id={`au-${2}`}
                correlativo={`${1}`}
                alias="alias"
                aliasTwo="code"
                select="alias"
                className="font-famiy-homologationDriver"
                idItem="id"
                filter={props.equip}
                handleSubmitAutoComplete={props.handleSubmitAutoComplete}
                //  checkIfExist={props.checkIfExist}
                clear={props.clear}
                unClear={props.unClear}
                focus={props.focus}
                handleFocus={props.handleFocus}
                clearRow={props.clearRow}
                handleSelect={props.handleSelect}
                allocatorActions={props.allocatorActions}
              />
            </div>
          </td>
          <td>
            <div className="test-allocator">
              <div className="box-form box-form-size">
                <i className="fal fa-calendar-alt fal-second" />
                <DateFilter
                  date={validateDate(
                    props.filters.date.fechaStartFinal,
                    props.date.response.maxDate
                  )}
                  dif={props.filters.date.fechaStartFinal ? 0 : -1123200000}
                  id="date-start"
                  handleSubmit={props.handleSubmit}
                  first={true}
                  defaultDate={props.defaultDate}
                />
              </div>
              <div className="box-form padding-left">
                <i className="fal fa-clock fal-second" />
                <TimePicker id="init" handleSubmitTime={props.handleSubmitTime} first={true} />
              </div>
            </div>
          </td>
          <td>
            <input id={`homologation-id-${1}`} type="hidden" data-homologation="ok" />
            <div className="test-allocator">
              <div className="box-form">
                <i className="fal fa-calendar-alt fal-second" />
                <DateFilter
                  date={validateDate(
                    props.filters.date.fechaStartFinal,
                    props.date.response.maxDate
                  )}
                  dif={props.filters.date.fechaStartFinal ? 0 : -1123200000}
                  id="date-end"
                  handleSubmit={props.handleSubmit}
                  clearRow={props.clearRow}
                />
              </div>
              <div className="box-form padding-left">
                <i className="fal fa-clock fal-second" />
                <TimePicker
                  id="end"
                  handleSubmitTime={props.handleSubmitTime}
                  clearRow={props.clearRow}
                />
              </div>
              <div className="tooltip-wraper tooltip-asignador">
                <span className={`icon-delete`}>
                  <i className="fa fa-plus-square" onClick={props.handleAsignation} />
                </span>
                <div className="toolti">
                  <span className="tooltptext">Guardar</span>
                </div>
              </div>
              <div className="tooltip-wraper tooltip-asignador-delete">
                <span className={`icon-edit`}>
                  <i className="fas fa-times-circle " onClick={props.clearAsignation} />
                </span>
                <div className="toolti">
                  <span className="tooltptext">Limpiar</span>
                </div>
              </div>
            </div>
          </td>
        </tr>
        <TableRow
          datStartFinal={props.filters.date.fechaStartFinal}
          maxDate={props.date.response.maxDate}
          dif={props.filters.date.fechaStartFinal}
          handleSubmit={props.handleSubmit}
          datos={props.datos}
          filter={props.datosAccount}
          dataRow={props.dataRow}
          handleSubmitTime={props.handleSubmitTime}
          handleSubmitAutoComplete={props.handleSubmitAutoComplete}
          close={props.close}
          handleClose={props.handleClose}
          handleOpen={props.handleOpen}
          isDriver={props.isDriver}
          test={props.test ? props.test : []}
          driverName={props.driverName}
          checkIfExist={props.checkIfExist}
          handleDriverName={props.handleDriverName}
          handleChangeSelectedName={props.handleChangeSelectedName}
          empty={true}
          deleteAsignation={props.deleteAsignation}
        />
      </tbody>
    </table>
  </div>
);

export default Table;



// WEBPACK FOOTER //
// ./source/client/components/allocator/table.jsx